module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/purple-fd96341adf03757d0a78d08608606e18.png";